import { AppUser } from 'Src/views/App/App';
import axios from 'Src/helpers/api/axiosInstance';
import { DEFAULT_LIMIT, DEFAULT_SKIP } from 'Src/consts/table';

const DEFAULT_REQUESTS_FILTER: any = {
  status: 'NEW'
};

/** REQUEST TABLE */
export function getRequests(user: AppUser, filter = DEFAULT_REQUESTS_FILTER) {
  const { roleSessionKey: key, activeSchoolId } = user;

  const config = {
    headers: { usid: key },
    params: {
      filter: {
        where: {
          ...DEFAULT_REQUESTS_FILTER,
          ...filter.where
        },
        skip: filter.skip,
        limit: filter.limit,
        order: filter.order
      }
    }
  };

  return axios.get(`${window.apiBase}/i/schools/${activeSchoolId}/permissions/requests`, config).then(response => {
    return response.data;
  });
}

export function getRequestsCount(user: AppUser, where?) {
  const { roleSessionKey: key, activeSchoolId } = user;
  const config = {
    headers: { usid: key },
    params: { filter: { where: { ...DEFAULT_REQUESTS_FILTER, ...(where || {}) } } }
  };

  return axios
    .get(`${window.apiBase}/i/schools/${activeSchoolId}/permissions/requests/count`, config)
    .then(response => response.data);
}

export function getAllRequests(user: AppUser, where?) {
  const { roleSessionKey: key, activeSchoolId } = user;

  let config;

  if (typeof where !== 'undefined') {
    config = {
      headers: { usid: key },
      params: {
        filter: {
          where: {
            ...DEFAULT_REQUESTS_FILTER,
            ...where
          },
          limit: DEFAULT_LIMIT,
          skip: DEFAULT_SKIP
        }
      }
    };
  } else {
    config = {
      headers: { usid: key },
      params: {
        filter: {
          where: {
            ...DEFAULT_REQUESTS_FILTER
          },
          limit: DEFAULT_LIMIT,
          skip: DEFAULT_SKIP
        }
      }
    };
  }

  return axios.get(`${window.apiBase}/i/schools/${activeSchoolId}/permissions/requests`, config).then(response => {
    return response.data;
  });
}

export function updateRequest(user: AppUser, requestId, data) {
  const { roleSessionKey: key, activeSchoolId } = user;

  const config = {
    headers: { usid: key }
  };

  return axios
    .put(`${window.apiBase}/i/schools/${activeSchoolId}/permissions/requests/${requestId}/status`, data, config)
    .then(response => {
      return response.data;
    });
}

export function getRequest(user: AppUser, requestId: string) {
  const { roleSessionKey: key, activeSchoolId } = user;

  const config = {
    headers: { usid: key }
  };

  return axios
    .get(`${window.apiBase}/i/schools/${activeSchoolId}/permissions/requests/${requestId}`, config)
    .then(response => {
      return response.data;
    });
}

export function getMergeableUsers(user: AppUser, filter) {
  const { roleSessionKey: key, activeSchoolId } = user;

  const config = {
    headers: { usid: key },
    params: {
      filter
    }
  };

  return axios.get(`${window.apiBase}/i/schools/${activeSchoolId}/mergeableUsers`, config).then(response => {
    return response.data;
  });
}

export function mergeUserStaff(user: AppUser, userId, data) {
  const { roleSessionKey: key, activeSchoolId } = user;

  const config = {
    headers: { usid: key }
  };

  return axios
    .post(`${window.apiBase}/i/schools/${activeSchoolId}/users/${userId}/merge`, data, config)
    .then(response => {
      return response.data;
    });
}
